import React from "react";
export type Tone = "light" | "cream" | "dark";
type SectionProps = {
  tone?: Tone;
  id?: string;
  className?: string;
  children: React.ReactNode;
};
const toneClasses: Record<Tone, string> = {
  light: "bg-white text-navy-900",
  cream: "bg-cream text-navy-900",
  dark: "bg-navy-900 text-white"
};
export function Section({
  tone = "light",
  id,
  className = "",
  children
}: SectionProps) {
  return <section id={id} className={`${toneClasses[tone]} px-5 py-16 md:py-24 ${className}`} data-id="element-214" data-mp="cgpwhupnlozq">
      <div className="mx-auto w-full max-w-6xl" data-id="element-215" data-mp="hf15k384jvgw">{children}</div>
    </section>;
}
type HeadingProps = {
  eyebrow?: string;
  title: string;
  intro?: string[];
  tone?: Tone;
};
export function SectionHeading({
  eyebrow,
  title,
  intro,
  tone = "light"
}: HeadingProps) {
  const dark = tone === "dark";
  return <header className="mx-auto max-w-3xl text-center" data-id="element-216" data-mp="vdhlmkrvmybp">
      {eyebrow && <p className={`text-xs font-bold uppercase tracking-[0.18em] md:text-sm ${dark ? "text-gold-400" : "text-gold-700"}`} data-id="element-217" data-mp="105r6vni1ra7n">
          {eyebrow}
        </p>}
      <h2 className="mt-3 text-balance font-serif text-[2rem] font-bold leading-[1.12] md:text-5xl" data-id="element-218" data-mp="2uma7wgl9eu3v">
        {title}
      </h2>
      {intro && <div className={`mt-5 space-y-4 text-[17px] leading-relaxed md:text-lg ${dark ? "text-white/80" : "text-navy-900/75"}`} data-id="element-219" data-mp="38f04feyezhf8">
          {intro.map(p => <p key={p} data-id="element-220" data-mp="3i9s18gk6a08y">{p}</p>)}
        </div>}
    </header>;
}